import React, { Component, PropsWithChildren } from 'react';
import i18n from '../../i18n';

export class ErrorBoundary extends Component<
  PropsWithChildren<Record<string, unknown>>
> {
  state: { hasError: boolean } = { hasError: false };

  componentDidCatch() {
    this.setState({ hasError: true });
  }

  render() {
    return this.state.hasError ? (
      <p>{i18n.t('The application is temporarily unavailable')}</p>
    ) : (
      this.props.children
    );
  }
}
